import classNames from 'classnames';
import Image, { ImageProps } from 'next/image';
import { ReactElement } from 'react';
import HeaderBgLines from './assets/header-bg-lines.png';

export const TabWithSideImageContent = ({
  heading,
  bullets,
  img,
  bgDecoration,
  description,
  Diagram,
}: {
  heading: string;
  bullets: string[];
  img?: ImageProps;
  bgDecoration?: boolean;
  description?: string;
  Diagram?: () => ReactElement;
}) => (
  <div
    className={classNames([
      'to-background relative isolate flex h-full flex-col gap-x-4 gap-y-10 overflow-hidden bg-gradient-to-b from-white p-10 max-sm:px-5 md:flex-row xl:gap-6',
      bgDecoration && 'md:pr-0',
    ])}
  >
    <div className={classNames('z-20', bgDecoration ? 'shrink-0 md:w-1/2 xl:flex-[0_0_23.75rem]' : 'md:flex-1 md:min-w-0')}>
      <h2 className="text-xl md:text-2xl md:whitespace-pre-line xl:text-3xl">
        {heading}
      </h2>
      <p className="mt-[10px]">{description}</p>
      <ul className="mt-6 list-disc pl-5 font-light">
        {bullets.map((item) => (
          <li key={item} className="xl:text-m md:whitespace-pre-line">
            {item}
          </li>
        ))}
      </ul>
    </div>
    <div className={classNames('z-10', bgDecoration ? 'self-center' : 'flex flex-1 items-center justify-center')}>
      {Diagram ? (
        <div className="relative flex w-full justify-center">
          <Diagram />
        </div>
      ) : (
        img && (
          <Image
            src={img.src}
            quality={100}
            width={img.width}
            height={img.height}
            alt={img.alt ?? ''}
            loading="eager"
            className={classNames([
              'block max-h-80 object-contain object-center',
              img.className,
            ])}
          />
        )
      )}
    </div>
    {bgDecoration && (
      <Image
        className="pointer-events-none absolute bottom-0 left-0 -z-10 h-full w-[95%] max-w-[62rem] object-fill max-md:hidden"
        src={HeaderBgLines}
        alt={''}
      />
    )}
  </div>
);
